import { SubscriptionsForOrganisationView } from '@src/api';
import { GroupUI } from '@src/models';

export const mapSubscriptionToGroupUI = (subscription: SubscriptionsForOrganisationView): GroupUI => {
  return {
    ...subscription,
    isChannel: subscription.chatTypeId === 2, // INFO: 1 - групповой чат; 2 - канал
  };
};
